/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

const OPEN_MOBILE = 'روی «باز کردن وب‌اپلیکیشن» پایین بزن تا اپ باز بشه.'
const OPEN_DESKTOP = 'روی «باز کردن وب‌اپلیکیشن» پایین بزن تا اپ توی یه تب جدید باز بشه.'

function detect() {
  const u = navigator.userAgent || ''
  const p = navigator.platform || ''
  const touch = navigator.maxTouchPoints || 0
  const android = /Android/.test(u)
  const ipad = p === 'MacIntel' && touch > 1 && !android && !/Chrome|Firefox|Edg|OPR/.test(u)
  const ios = !android && (/iPhone|iPad|iPod/.test(u) || ipad)
  const os = ios ? 'iOS' : android ? 'Android' : /Windows/.test(u) ? 'Windows' : /CrOS/.test(u) ? 'ChromeOS' : /Mac/.test(u) ? 'macOS' : /Linux|X11/.test(u) ? 'Linux' : ''
  let browser = ''
  if (/Edg|EdgA|EdgiOS/.test(u)) browser = 'Edge'
  else if (/OPR|Opera|OPiOS/.test(u)) browser = 'Opera'
  else if (/Vivaldi/.test(u)) browser = 'Vivaldi'
  else if (/SamsungBrowser/.test(u)) browser = 'Samsung Internet'
  else if (/Firefox|FxiOS/.test(u)) browser = 'Firefox'
  else if (/Chrome|CriOS/.test(u)) browser = navigator.brave ? 'Brave' : /Arc\//.test(u) ? 'Arc' : 'Chrome'
  else if (/Safari/.test(u)) browser = 'Safari'
  return { os, browser, ios, android, ipad: /iPad/.test(u) }
}

const CHROMIUM = ['Chrome', 'Edge', 'Brave', 'Opera', 'Vivaldi', 'Arc']

export function buildGuide() {
  const e = detect()
  const { os, browser } = e
  const name = (browser || 'مرورگر') + (os ? ' · ' + os : '')
  if (e.ios) {
    const title = 'نصب روی ' + (os === 'iOS' && e.ipad ? 'آیپد' : 'آیفون و آیپد') + (browser ? ' (' + browser + ')' : '')
    const steps =
      browser === 'Safari' || !browser
        ? [[OPEN_MOBILE], ['دکمه‌ی اشتراک‌گذاری ', 'SH', ' پایین صفحه رو بزن.'], ['«افزودن به صفحه‌ی اصلی» (Add to Home Screen) رو انتخاب کن.'], ['روی «افزودن» بزن؛ آیکون سکویا میاد روی صفحه‌ی اصلی.']]
        : [[OPEN_MOBILE], ['نصب وب‌اپ روی iOS مطمئن‌تر از Safari انجام می‌شه؛ لینک رو توی Safari باز کن.'], ['دکمه‌ی اشتراک‌گذاری ', 'SH', ' رو بزن و «افزودن به صفحه‌ی اصلی» رو انتخاب کن.']]
    return { title, steps }
  }
  if (e.android) {
    const title = 'نصب روی اندروید' + (browser ? ' (' + browser + ')' : '')
    let steps
    if (CHROMIUM.includes(browser)) steps = [[OPEN_MOBILE], ['روی دکمه‌ی سه‌نقطه ', 'MV', ' مرورگر بزن.'], ['«نصب برنامه» (Install app) یا «افزودن به صفحه‌ی اصلی» رو انتخاب کن.'], ['تأیید کن؛ آیکون سکویا میاد روی صفحه‌ی اصلی.']]
    else if (browser === 'Firefox') steps = [[OPEN_MOBILE], ['روی منوی سه‌نقطه ', 'MV', ' بزن.'], ['«نصب» یا «افزودن به صفحه‌ی اصلی» رو انتخاب کن.'], ['تأیید کن تا آیکون سکویا روی صفحه‌ی اصلی بیاد.']]
    else if (browser === 'Samsung Internet') steps = [[OPEN_MOBILE], ['روی منوی پایین مرورگر (سه خط) بزن.'], ['«افزودن صفحه به» و بعد «صفحه‌ی اصلی» رو انتخاب کن.']]
    else steps = [[OPEN_MOBILE], ['منوی مرورگر رو باز کن.'], ['«افزودن به صفحه‌ی اصلی» یا «نصب» رو بزن.'], ['اگه گزینه‌ای نبود، لینک رو توی Chrome باز کن.']]
    return { title, steps }
  }
  const title = 'نصب روی ' + name
  if (browser === 'Safari' && os === 'macOS') {
    return { title, steps: [[OPEN_DESKTOP], ['از نوار بالای Safari دکمه‌ی اشتراک‌گذاری ', 'SH', ' رو بزن.'], ['«افزودن به Dock» (Add to Dock) رو انتخاب کن.'], ['سکویا مثل یه برنامه‌ی جدا توی Dock میاد.']] }
  }
  if (browser === 'Edge') {
    return { title, steps: [[OPEN_DESKTOP], ['آیکون نصب ', 'IN', ' سمت راست نوار آدرس رو بزن؛ یا منوی سه‌نقطه ', 'MV', ' ← «برنامه‌ها» (Apps).'], ['«نصب این سایت به عنوان برنامه» (Install this site as an app) رو انتخاب کن.'], ['روی «نصب» بزن؛ سکویا مثل یه برنامه‌ی جدا باز می‌شه.']] }
  }
  if (CHROMIUM.includes(browser)) {
    const second = ['آیکون نصب ', 'IN', ' سمت راست نوار آدرس رو بزن.']
    if (browser === 'Chrome' || browser === 'Brave') second.push(' اگه نبود، منوی سه‌نقطه ', 'MV', ' ← «ارسال، ذخیره و اشتراک‌گذاری» ← «نصب سکویا».')
    else second.push(' اگه نبود، منوی مرورگر رو باز کن و دنبال «نصب» بگرد.')
    return { title, steps: [[OPEN_DESKTOP], second, ['روی «نصب» (Install) بزن؛ سکویا مثل یه برنامه‌ی جدا باز می‌شه.']] }
  }
  if (browser === 'Firefox') {
    return { title, steps: [[OPEN_DESKTOP], ['Firefox روی ویندوز و لینوکس نصب وب‌اپ رو پشتیبانی نمی‌کنه (روی مک هم نه).'], ['برای نصب، لینک رو توی Chrome یا Edge باز کن؛ یا همین‌جا از تب مرورگر استفاده کن.']] }
  }
  if (browser === 'Safari') {
    return { title, steps: [[OPEN_DESKTOP], ['نصب وب‌اپ از Safari نسخه‌ی ۱۷ به بالا روی macOS ممکنه؛ Safari رو به‌روز کن یا از Chrome یا Edge استفاده کن.']] }
  }
  return { title: 'نصب وب‌اپلیکیشن', steps: [[OPEN_DESKTOP], ['این مرورگر نصب وب‌اپ رو پشتیبانی نمی‌کنه؛ لینک رو توی Chrome یا Edge باز کن.']] }
}
